import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TbMessageSearch } from "react-icons/tb";
import { Modal, useTheme } from "@mui/material";
import "./index.css";
import { useRouter } from "../../hooks/useRouter";
import { getProticoClient, API_GET_NOTIFICATION_UNREAD } from "../../utils/api";
import { ROUTES } from "../../routes";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { useAppSelector } from "../../hooks";

const NotificationModal = () => {
  const { t } = useTranslation();
  const { address } = useWeb3Auth();
  const { setNotificationUnreadCount, roomDomain } = useWhiteboardRoom();
  const theme = useTheme();
  const [modalOpen, setModalOpen] = React.useState(false);
  const { push } = useRouter();
  const { lastBToCTarget } = useAppSelector((state) => state.bToCState);


  const handleNotiClick = () => {
    push({
      pathname: `${ROUTES.B_TO_C_PAGE}/${
        lastBToCTarget?.toDomain && lastBToCTarget.toDomain || roomDomain
      }`
    });
    setModalOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      let response = await getProticoClient().api.get(API_GET_NOTIFICATION_UNREAD);
      if (response.data.count > 0) {
        setNotificationUnreadCount(response.data.count);
        setModalOpen(true);
      }
    };
    if (address) {
      fetchData();
    }
  }, [address]);

  return (
    <Modal open={modalOpen} className="notification-modal-container" onClose={()=>{setModalOpen(false)}}>
      <>
        <div className="notification-modal-title">
        {t("Notification_Modal_Title")}
        </div>
        <div className="notification-modal-desc">{t("Notification_Modal_Desc")}</div>
        <button
          className="notification-modal-button-start"
          onClick={handleNotiClick}
          style={{
            backgroundColor: theme.brandColor,
          }}
        >
          {t("Notification_Modal_Btn")}
          <TbMessageSearch className="notification-modal-button-icon" />
        </button>        
      </>
    </Modal>
  );
};

export default NotificationModal;
